import React, { Component } from 'react';
import SearchTextBox from 'share/components/controls/Izenda.SearchTextBox';

export default class NlQSearchBox extends Component {

  componentDidUpdate(prevProps) {
    const suggestionChanged = prevProps.value != this.props.value;
    const enabledFirstTime = this.props.shouldFocus && prevProps.disabled && !this.props.disabled;
    if(enabledFirstTime || suggestionChanged) {
      this.focusCaller && this.focusCaller();
    }
  }

  render() {
    const { shouldFocus, disabled, value, placeholder, onKeyPress, onChange, isActive } = this.props;
    return (
      <div className='search-wrapper'>
        <div className='input-box'>
          {isActive && (
            <SearchTextBox
              clickable
              className='explore-search-input'
              placeholder={placeholder}
              value={value}
              onKeyPress={onKeyPress}
              shouldFocus={shouldFocus}
              disabled={disabled}
              onChange={onChange}
              focusCaller={caller => this.focusCaller = caller}
            />
          )}
        </div>
        {this.props.children}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQSuggestionBox/Izenda.NlQSearchBox.js